module.exports = __webpack_public_path__ + "static/media/trampoline.5144a8b3.png";